// VisorPuente.vue (Asume que está configurado en tu router para la ruta /visor-puente)

<template>
  <div style="text-align: center; padding-top: 50px;">
    <h1>Cargando documento...</h1>
    <p>Si la redirección no funciona, haga clic <a :href="fileUrl" target="_self">aquí</a>.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileUrl: '',
      // No necesitamos título aquí, pero se puede usar para el <title>
    };
  },
  mounted() {
    // 1. Obtener la URL del archivo real del query string
    const urlParams = new URLSearchParams(window.location.search);
    const fileUrl = urlParams.get('url');

    if (fileUrl) {
      this.fileUrl = decodeURIComponent(fileUrl);
      
      // 2. Iniciar la redirección al archivo real
      window.location.replace(this.fileUrl);

      // Opcional: Establecer el título de la página
      // const title = urlParams.get('title') || 'Documento';
      // document.title = decodeURIComponent(title);
    } else {
      console.error('URL de archivo no encontrada.');
    }
  },
};
</script>